import onlyweb from "../src/assets/DownloadOurMobileApp.png"
import hoSakshamLogo from "../src/assets/HosakshamHorizontal.png"
import googlePlayBadges from "../src/assets/GooglePlayBadges.png"
import appleStoreBadges from "../src/assets/app store badge.png"


export default function SmallScreenLayout(){
    return (
        <div className={"block h-[100vh] bg-blue-800 justify-center items-center"}>
        <div className={"flex flex-col justify-center h-[100vh] relative items-center bg-cc_bg-active w-full"}>
            <img src={onlyweb} alt={"download our mobile app"} />
            <p className={"text- font-semibold w-[85%] "}>Download our mobile app for a seamless experience and
                additional features.</p>
            <div className={"flex items-center  gap-4 mt-4"}>
                <img className={"cursor-pointer w-32 h-12"} onClick={() => {
                    location.replace("https://play.google.com/store/apps/details?id=com.besaksham.provider&hl=en_IN&gl=US&pli=1")
                }} src={googlePlayBadges} alt={"get from google play store"} />
                <img className={"cursor-pointer w-28  h-8"} onClick={() => {
                    location.replace("https://apps.apple.com/us/app/hosaksham/id6593680327")
                }} src={appleStoreBadges} alt={"get from apple store"} />
            </div>

        </div>
        <img className={"absolute top-5 max-w-[95%] left-[50%] -translate-x-1/2"} src={hoSakshamLogo}
            alt={"hoSaksham"} />

    </div>
    )
}